var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooksOnShelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70352 29.7055C3.5786 29.7055 2.66667 30.6174 2.66667 31.7424V31.7424C2.66667 32.8673 3.5786 33.7792 4.70352 33.7792H5.37335C6.35482 33.7792 7.15047 34.5748 7.15047 35.5563V35.5563C7.15047 36.5378 7.94611 37.3334 8.92758 37.3334H9.47438C10.4559 37.3334 11.2515 36.5378 11.2515 35.5563V35.5563C11.2515 34.5748 12.0471 33.7792 13.0286 33.7792H26.9721C27.9536 33.7792 28.7492 34.5748 28.7492 35.5563V35.5563C28.7492 36.5378 29.5449 37.3334 30.5263 37.3334H31.0731C32.0546 37.3334 32.8503 36.5378 32.8503 35.5563V35.5563C32.8503 34.5748 33.6459 33.7792 34.6274 33.7792H35.2972C36.4221 33.7792 37.3341 32.8673 37.3341 31.7424V31.7424C37.3341 30.6174 36.4221 29.7055 35.2972 29.7055H4.70352Z",
    fill: "#805AD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7932 9.69303L32.9331 9.03687L32.4684 5.42796C32.3863 4.85381 31.8669 4.44371 31.2927 4.52573L28.2306 4.88116C27.6565 4.96318 27.2464 5.48264 27.3284 6.05678L27.7932 9.69303Z",
    fill: "#805AD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0334 27.4089C30.1154 27.9831 30.6349 28.3932 31.209 28.3111L34.2711 27.9284C34.8453 27.8464 35.2554 27.3269 35.1734 26.7528L34.7086 23.1438L29.5686 23.8L30.0334 27.4089Z",
    fill: "#805AD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1184 10.3966L27.9648 11.05L29.4128 22.4693L34.5664 21.8158L33.1184 10.3966Z",
    fill: "#805AD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8522 3.73287C18.8522 3.15873 18.3874 2.6666 17.7859 2.6666H14.0403C13.4662 2.6666 12.9741 3.13139 12.9741 3.73287V7.36912H18.8522V3.73287Z",
    fill: "#805AD5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0396 28.3391H17.8125C18.3867 28.3391 18.8788 27.8743 18.8788 27.2728V23.6365H13.0007V27.2728C13.0007 27.8743 13.4654 28.3391 14.0396 28.3391Z",
    fill: "#805AD5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8788 8.73708H13.0007V22.2978H18.8788V8.73708Z",
    fill: "#805AD5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6867 5.75505C25.6867 5.18091 25.222 4.68878 24.6205 4.68878H21.5584C20.9842 4.68878 20.4921 5.15357 20.4921 5.75505V9.3913H25.6867V5.75505Z",
    fill: "#805AD5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5576 28.3391H24.647C25.2211 28.3391 25.7133 27.8743 25.7133 27.2728V23.6365H20.5186V27.2728C20.4913 27.8743 20.9561 28.3391 21.5576 28.3391Z",
    fill: "#805AD5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6867 10.7865H20.4921V22.2967H25.6867V10.7865Z",
    fill: "#805AD5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3605 3.73287C11.3605 3.15873 10.8957 2.6666 10.2943 2.6666H5.86514C5.291 2.6666 4.79887 3.13139 4.79887 3.73287V7.36912H11.3605V3.73287Z",
    fill: "#805AD5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79887 27.3001C4.79887 27.8743 5.26366 28.3664 5.86514 28.3664H10.2943C10.8684 28.3664 11.3605 27.9016 11.3605 27.3001V23.6365H4.79887V27.3001Z",
    fill: "#805AD5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3605 8.73708H4.79887V22.2978H11.3605V8.73708Z",
    fill: "#805AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksOnShelf);
export default __webpack_public_path__ + "static/media/BooksOnShelf.88cbf1a29bf1ced67741d774b66a9fd1.svg";
export { ForwardRef as ReactComponent };